import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import RomaneioTable from '../components/romaneio/RomaneioTable';

const Romaneio: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Romaneio
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gerencie os romaneios de saída e retorno de produtos
        </Typography>
      </Box>
      
      <RomaneioTable />
    </Container>
  );
};

export default Romaneio;
